import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import QueryString from 'query-string';
import { HeaderStepper } from '../../Common/HeaderStepper/HeaderStepper';
import * as Steps from './steps';
import { getSessionStorageItem, setSessionStorageItem, getBasicInfo, SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_ACTIVE_PURL } from '../../../../sessionStorage';
import { saveSessionEvent } from "../../../../session";
import PermData from '../../../Helpers/Data/Products/Perm/PermData';
import JuveData from '../../../Helpers/Data/Products/Juve/JuveData';
import IsJuvenile from '../../../Helpers/Dates/IsJuvenile';

import '../../Quoter.scss';
import './SecurianWL.scss';

export default function SecurianWL(props) {

  useEffect(() => { saveSessionEvent(); }, [props.location]);

  const { path } = useParams();
  const unavailableStates = ["CA", "NY"];
  const prefill = props.location && props.location.search && props.location.search.toLowerCase().includes('prefill');
  const juviMode = props.juvi || (props.location && props.location.search && props.location.search.toLowerCase().includes('juvi'));

  const account = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account;
  const accountId = account.accountId;
  const SESSION_STORAGE_KEY = juviMode ? 'SECURIAN_WL_JUVI' : 'SECURIAN_WL';
  const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_KEY);
  const isActivePurl = getSessionStorageItem(SESSION_STORAGE_ACTIVE_PURL).active;

  if (props.landing && sessionStorageFormState) {
    sessionStorageFormState.currentStep = 1;
  }
  const specs = juviMode ? JuveData().specs : PermData().specs;

  const basicInfo = getBasicInfo();
  if (basicInfo && basicInfo.state && unavailableStates.includes(basicInfo.state)) {
     basicInfo.state = '';
  }

  if (isActivePurl && basicInfo) {
    basicInfo.tobacco = "false";
  }

  const setFaceAmount = (value) => {
    if (juviMode && value > 75000) {
      return 75000;
    } else if (!juviMode && value > 150000) {
      return 150000;
    } else {
      return value;
    }
  };
  
  const newFormState = {
    currentStep: 1,
    pages: {
      basicInfo: Steps.BasicInfo.DefaultFormState(prefill, basicInfo, juviMode, null, isActivePurl),
      quoter: Steps.Quoter.DefaultFormState(prefill, basicInfo, setFaceAmount, isActivePurl),
      insuredInfo: Steps.InsuredInfo.DefaultFormState(prefill),
      beneficiaries: Steps.Beneficiary.DefaultFormState(prefill),
      medicalHistory: Steps.MedicalHistory.DefaultFormState(prefill),
      payment: Steps.Payment.DefaultFormState(prefill),
      consent: Steps.Consent.DefaultFormState(prefill),
    },
    productType: "MinnSPWL",
    oneClickAccountId: account.oneClickAccountId,
    consumerAccountId: accountId
  };

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  const isJuvenile = IsJuvenile(formState.pages.basicInfo.birthdate);

  useEffect(() => {
    // manually handle formState.currentStep if coming from esign since onNext wasn't called

    if (!path) {
      return;
    }

    if (path === 'status') {
      if (isJuvenile && !juviMode) {
        var url = window.location.href;
        url = url + "?juvi";
        window.top.location.href = url;
      }
      else if (formState.currentStep === steps.find(s => s.path === 'sign').step) {
        const newFormState = { ...formState, currentStep: steps.find(s => s.path === 'status').step };
        setFormState(newFormState);
      }
    }
  }, []);

  // update the formState when the url path changes the step
  useEffect(() => {
    if (!path) {
      return;
    }

    let nextStep = steps.find((s) => s.path === path);

    if (!nextStep) {
      return;
    }
    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path]);

  const getHeaderText = () => {
    const currentStep = formState.currentStep;
    if (currentStep === 1 || currentStep === 2) {
      return "Your Quote Results";
    } else {
      if (isJuvenile === true) {
        return "Secure Promise Children's Whole Life Insurance";
      } else {
        return "Secure Promise Whole Life Insurance";
      }
    }
  };

  const postConsumerApplication = (newFormState) => {
    if (!newFormState) {newFormState = formState;}
    const newForm = newFormState;
    return fetch(`api/ConsumerApplication/Post?accountId=${accountId}&productType=MinnSPWL`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify(newForm)
    })
    .then(res => res.json())
    .then(json => {
      setFormState({ ...formState, consumerApplicationId: json.consumerApplicationId });
    });
  };

  const onNext = () => {
    const nextStep = steps.find((s) => s.step === formState.currentStep + 1);

    if (!nextStep) {
      throw new Error('onNext did not find a next step');
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_KEY, newFormState);

    fetch(`api/ConsumerApplication/Post?accountId=${accountId}&productType=MinnSPWL`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
      },
      body: JSON.stringify(newFormState)
    });

    props.history.push(`/quote/whole-life/securian-secure-promise/${nextStep.path}${juviMode ? '?juvi' : ''}`);
    window.scroll(0, 0);
  };

  const ineligible = () => {
    setSessionStorageItem(SESSION_STORAGE_KEY, formState);
    props.history.push(`/Ineligible?productName=Secure Promise Whole Life Insurance`);
  };

  const onBack = () => {
    if (formState.currentStep <= 1) {
      window.location.replace('/');
    }

    const backStep = steps.find((s) => s.step === formState.currentStep - 1);
    if (!backStep) {
      throw new Error('onBack did not find a previous step');
    }

    const newFormState = { ...formState, currentStep: backStep.step };

    setFormState(newFormState);
    setSessionStorageItem(SESSION_STORAGE_KEY, newFormState);

    props.history.push(`/quote/whole-life/securian-secure-promise/${backStep.path}${juviMode ? '?juvi' : ''}`);
    window.scroll(0, 0);
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  };

  const steps = [
    {
      step: 1,
      path: 'basic-info',
      progressTitle: 'Basic Information',
      progressSubtitle: 'Enter your information for an estimated cost of insurance.',
      component: (
        <Steps.BasicInfo
          formState={formState.pages.basicInfo}
          onFieldChange={(field, value) => onFieldChange('basicInfo', field, value)}
          onNext={onNext}
          isTobaccoVerbiage={true}
          queryString={props.location ? QueryString.parse(props.location.search) : null}
          juviMode={juviMode}
          ageSpecs={specs.age}
          hideBack={props.landing}
          onBack={onBack}
          unavailableStates={unavailableStates}
        />
      ),
      hideProgressTracker: true,
    },
    {
      step: 2,
      path: 'get-a-quote',
      progressTitle: 'Get a Quote',
      component: (
        <Steps.Quoter
          formState={formState.pages.quoter}
          basicInfo={formState.pages.basicInfo}
          onFieldChange={(field, value, _step) => onFieldChange(_step || 'quoter', field, value)}
          ageSpecs={specs.age}
          onNext={onNext}
          onBack={onBack}
          queryString={props.location ? QueryString.parse(props.location.search) : null}
          coverageAmountSpecs={specs.coverageAmount}
        />
      ),
      hideProgressTracker: true,
    },
    {
      step: 3,
      path: 'insured-info',
      progressTitle: 'Proposed Insured Information',
      component: (
        <Steps.InsuredInfo
          formState={formState.pages.insuredInfo}
          basicInfo={formState.pages.basicInfo}
          onFieldChange={(field, value) => onFieldChange('insuredInfo', field, value)}
          onMultiFieldChange={(fs) => {
            setFormState(fs);
          }}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          onFormComplete={postConsumerApplication}
          unavailableStates={unavailableStates}
        />
      ),
    },
    {
      step: 4,
      path: 'beneficiaries',
      progressTitle: 'Beneficiary Information',
      component: (
        <Steps.Beneficiary
          formState={formState.pages.beneficiaries}
          onFieldChange={(field, value) => onFieldChange('beneficiaries', field, value)}
          onNext={onNext}
          onBack={onBack}
          basicInfo={formState.pages.basicInfo}
          unavailableStates={unavailableStates}
        />
      ),
    },
    {
      step: 5,
      path: 'medical-history',
      progressTitle: 'Medical History',
      component: (
        <Steps.MedicalHistory
          formState={formState.pages.medicalHistory}
          onFieldChange={(field, value) => onFieldChange('medicalHistory', field, value)}
          onNext={onNext}
          onBack={onBack}
          formStateForUnderwriting={formState}
          ineligible={ineligible}
        />
      ),
    },
    {
      step: 6,
      path: 'payment-info',
      progressTitle: 'Payment Information',
      component: (
        <Steps.Payment
          formState={formState.pages.payment}
          insuredInfo={formState.pages.insuredInfo}
          onFieldChange={(field, value) => onFieldChange('payment', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
    },
    {
      step: 7,
      path: 'verify',
      progressTitle: 'Verification and Consent',
      component: <Steps.Verify formState={formState} onNext={onNext} onBack={onBack} />,
    },
    {
      step: 8,
      path: 'consent',
      progressTitle: 'Verification and Consent',
      component: (
        <Steps.Consent
          formState={formState.pages.consent}
          fullFormState={formState}
          onFieldChange={(field, value) => onFieldChange('consent', field, value)}
          onNext={onNext}
          onBack={onBack}
        />
      ),
    },
    {
      step: 9,
      path: 'sign',
      progressTitle: 'Verification and Consent',
      component: (
        <Steps.Sign
          formState={formState}
          onNext={onNext}
          onBack={onBack}
        />
      ),
    },
    {
      step: 10,
      path: 'status',
      progressTitle: 'Application Complete',
      component: (
        <Steps.Status
          formState={formState}
        />
      ),
    },
  ];

  const currentStepObj = steps.find((s) => s.step === formState.currentStep) || steps[0];

  return (
    <div>
      <Helmet>
        <title> {juviMode ? "Children's life insurance" : "Permanent life insurance"}  - {currentStepObj.progressTitle}</title>
      </Helmet>

      <HeaderStepper title={getHeaderText()} hidden={props.landing} hideProgressTracker={currentStepObj.hideProgressTracker} stepName={currentStepObj.progressTitle} step={formState.currentStep} totalSteps={steps.length}>
        <div className="securianWL">
          {currentStepObj.component}
        </div>
      </HeaderStepper>
    </div>
  );
}

SecurianWL.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
  landing: PropTypes.bool,
  juvi: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Securian/WL/SecurianWL.js